import * as React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts'
import type { StockVelocityRow } from '@/lib/api-client'

const BRANCH_COLORS: Record<string, string> = {
  Putrajaya: '#2563eb',
  Bangi: '#10b981',
  'Shah Alam': '#f59e0b',
  'Kuala Lumpur': '#8b5cf6',
}
const ORDER = ['Putrajaya', 'Bangi', 'Shah Alam', 'Kuala Lumpur']

export function UnitsByBranchChart({ velocity }: { velocity: StockVelocityRow[] }) {
  const data = React.useMemo(() => {
    const m = new Map<string, { branch: string; units: number; skus: Set<number> }>()
    for (const v of velocity) {
      const e = m.get(v.branch) ?? { branch: v.branch, units: 0, skus: new Set<number>() }
      e.units += v.qty
      if (v.qty > 0) e.skus.add(v.skuId)
      m.set(v.branch, e)
    }
    return [...m.values()]
      .map((e) => ({ branch: e.branch, units: Math.round(e.units), skus: e.skus.size }))
      .sort((a, b) => ORDER.indexOf(a.branch) - ORDER.indexOf(b.branch))
  }, [velocity])

  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <h3 className="text-sm font-semibold text-text-dark mb-3">Units sold by branch</h3>
      <div className="h-[260px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 12, bottom: 4, left: -12 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" vertical={false} />
            <XAxis dataKey="branch" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
            <Tooltip
              contentStyle={{ fontSize: 12, borderRadius: 8 }}
              formatter={(val: any, _n: any, p: any) => [`${val} units · ${p.payload.skus} SKUs`, p.payload.branch]}
            />
            <Bar dataKey="units" radius={[6, 6, 0, 0]}>
              {data.map((d) => (
                <Cell key={d.branch} fill={BRANCH_COLORS[d.branch] ?? '#64748b'} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  )
}
